import { Component, Input, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import { MatDatepickerInputEvent, MatDateRangePicker } from '@angular/material/datepicker'
import { required } from '@widgets/validation'
import moment from 'moment'

const DATE_FORMAT = 'YYYY-MM-DD'

@Component({
  selector: 'bdg-date-range-field',
  templateUrl: './date-range-field.component.html',
  styleUrls: ['./date-range-field.component.scss'],
})
export class DateRangeFieldComponent {
  @Input()
  placeholderStart = 'dd/mm/aaaa'

  @Input()
  placeholderEnd = 'dd/mm/aaaa'

  @Input()
  startDateControl: FormControl

  @Input()
  endDateControl: FormControl

  @Input()
  filter: () => {}

  @Input()
  label: ''

  @Input()
  hint: ''

  @ViewChild('picker')
  picker: MatDateRangePicker<moment.Moment>

  onStartDateInput(event: MatDatepickerInputEvent<moment.Moment>) {
    this.startDateControl.setValue(moment(event.value, DATE_FORMAT))
  }

  onEndDateInput(event: MatDatepickerInputEvent<moment.Moment>) {
    this.endDateControl.setValue(moment(event.value, DATE_FORMAT))
  }

  error() {
    if (!this.startDateControl?.touched && !this.endDateControl?.touched) {
      return null
    }

    const hasMatError =
      this.startDateControl.errors?.matDatepickerParse || this.endDateControl.errors?.matDatepickerParse

    return hasMatError ? required('') : this.startDateControl.errors?.error || this.endDateControl.errors?.error
  }

  onPickerClicked() {
    this.picker.open()
  }
}
